'use client';

import { PlayBtn } from '@marine/icons';
import { FC, useState } from 'react';
import { VideoModal, VideoModalState } from '../../VideoModal';
import styles from './AllFeaturesPage.module.scss';

interface VideoPlayerClientProps {
  videoUrl?: string | null;
}

export const VideoPlayerClient: FC<VideoPlayerClientProps> = ({ videoUrl }) => {
  const [isModalVisible, setIsModalVisible] = useState<VideoModalState>('NOT_OPENED');
  const showVideoModal = (): void => {
    setIsModalVisible('OPEN');
  };

  const closeVideoModal = (): void => {
    setIsModalVisible('CLOSED');
  };

  return (
    <>
      {videoUrl ? <PlayBtn onClick={showVideoModal} className={styles.playBtn} /> : null}
      <VideoModal isModalVisible={isModalVisible} closeVideoModal={closeVideoModal} src={videoUrl ? videoUrl : ''} />
    </>
  );
};
